import { render, staticRenderFns } from "./YouSureQuestion.vue?vue&type=template&id=5df11d54&scoped=true&"
import script from "./YouSureQuestion.vue?vue&type=script&lang=ts&"
export * from "./YouSureQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df11d54",
  null
  
)

export default component.exports